<template>
    <div>
        <!--
            BLOCO G — item 70: composição de gestão da unidade.

            NÃO substitui a lotação (vínculo funcional do RH). Um servidor pode estar
            lotado na escola sem integrar a equipe diretiva.

            Nenhum id é digitado: o servidor sai da lista dos que têm lotação vigente na
            própria escola, e a função vem do catálogo `funcoes_servidor`.
        -->
        <el-alert type="info" :closable="false" class="u-mb-15"
            title="Quem responde pela unidade em cada período letivo, com ato de designação e vigência."
            description="Para trocar o titular de uma função, encerre a designação anterior informando a data final — não exclua o registro."></el-alert>

        <el-form label-position="top" @submit.native.prevent>
            <el-row :gutter="10" class="u-mb-15">
                <el-col :xs="24" :sm="10">
                    <el-form-item label="Período letivo" class="u-mb-0">
                        <el-select v-model="periodoId" style="width: 100%;" @change="carregar">
                            <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="14" class="u-text-right u-mt-25">
                    <el-button v-if="podeEscrever" size="small" type="primary" icon="el-icon-plus" @click="abrirNovo">
                        NOVA DESIGNAÇÃO
                    </el-button>
                </el-col>
            </el-row>
        </el-form>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Servidor</th>
                        <th style="width: 200px;">Função</th>
                        <th style="width: 160px;">Ato de designação</th>
                        <th style="width: 200px;">Vigência</th>
                        <th style="width: 110px;" class="u-text-center">Situação</th>
                        <th style="width: 120px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="e in itens" :key="e.id">
                        <td>
                            {{ e.servidor ? e.servidor.nome : '—' }}
                            <el-tag v-if="e.principal" size="mini" type="success" class="u-ml-5">titular</el-tag>
                        </td>
                        <td>{{ e.funcao ? e.funcao.nome : '—' }}</td>
                        <td>{{ e.ato_designacao || '—' }}</td>
                        <td>
                            {{ dataBr(e.data_inicio) }}
                            <span v-if="e.data_fim"> a {{ dataBr(e.data_fim) }}</span>
                            <span v-else class="u-text-muted"> — sem termo</span>
                        </td>
                        <td class="u-text-center">
                            <el-tag v-if="e.vigente" size="mini" type="success">Vigente</el-tag>
                            <el-tag v-else size="mini" type="info">Encerrada</el-tag>
                        </td>
                        <td class="u-text-center acao">
                            <el-button v-if="podeEscrever" @click="abrirEdicao(e)" type="info" icon="el-icon-edit" size="mini" plain></el-button>
                            <el-button class="u-ml-10" v-if="podeEscrever" @click="excluir(e)" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            <span v-if="!podeEscrever">—</span>
                        </td>
                    </tr>
                    <tr v-if="itens.length === 0"><td colspan="6" class="u-text-center">Nenhuma designação neste período letivo.</td></tr>
                </tbody>
            </table>
        </div>

        <el-dialog :title="form.id ? 'Editar designação' : 'Nova designação'" :visible.sync="dialogo" width="560px" append-to-body>
            <el-form label-position="top">
                <el-form-item label="Servidor">
                    <el-select v-model="form.servidor_id" filterable style="width: 100%;" :disabled="!!form.id"
                        no-data-text="Nenhum servidor com lotação vigente nesta escola">
                        <el-option v-for="s in servidores" :key="s.id" :value="s.id"
                            :label="s.nome + (s.matricula ? ' — ' + s.matricula : '')"></el-option>
                    </el-select>
                    <small v-if="form.id">O servidor não muda por edição — uma troca é uma designação nova.</small>
                </el-form-item>

                <el-form-item label="Função">
                    <el-select v-model="form.funcao_servidor_id" style="width: 100%;" :disabled="!!form.id">
                        <el-option-group label="Funções de gestão">
                            <el-option v-for="f in funcoesGestao" :key="'g' + f.id" :value="f.id" :label="f.nome"></el-option>
                        </el-option-group>
                        <el-option-group label="Demais funções">
                            <el-option v-for="f in funcoesOutras" :key="'o' + f.id" :value="f.id" :label="f.nome"></el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Início da designação">
                            <el-date-picker v-model="form.data_inicio" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Fim (em branco = sem termo)">
                            <el-date-picker v-model="form.data_fim" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Ato de designação">
                    <el-input v-model="form.ato_designacao" placeholder="Portaria nº 12/2026"></el-input>
                </el-form-item>

                <el-checkbox v-model="form.principal">É o titular da função (por oposição ao substituto)</el-checkbox>
            </el-form>

            <span slot="footer">
                <el-button @click="dialogo = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" :disabled="!form.servidor_id || !form.funcao_servidor_id || !form.data_inicio"
                    @click="salvar">SALVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
/** BLOCO G — itens 70 e 30. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    props: {
        instituicaoId: { type: [Number, String], required: true }
    },
    data: () => ({
        periodoId: null, itens: [], servidores: [],
        funcoesGestao: [], funcoesOutras: [],
        dialogo: false,
        form: { id: null, servidor_id: null, funcao_servidor_id: null, data_inicio: '',
                data_fim: '', ato_designacao: '', principal: false }
    }),
    computed: {
        podeEscrever () { return [0, 1, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/equipe-diretiva/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            const gestao = (r.data && r.data.funcoes_gestao) ? r.data.funcoes_gestao : []
            const todas = (r.data && r.data.funcoes) ? r.data.funcoes : []
            const idsGestao = gestao.map(f => f.id)
            this.funcoesGestao = gestao
            this.funcoesOutras = todas.filter(f => idsGestao.indexOf(f.id) === -1)
        }).catch(e => this.$store.commit('throwException', e))

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/equipe-diretiva/getServidores/${this.instituicaoId}`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.servidores = Array.isArray(r.data) ? r.data : [] })
         .catch(e => this.$store.commit('throwException', e))

        this.carregar()
    },
    methods: {
        carregar () {
            this.itens = []
            if (!this.periodoId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/equipe-diretiva/getByInstituicao/${this.instituicaoId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.itens = r.data.itens || []
            }).catch(e => this.$store.commit('throwException', e))
        },
        abrirNovo () {
            this.form = { id: null, servidor_id: null, funcao_servidor_id: null, data_inicio: '',
                data_fim: '', ato_designacao: '', principal: false }
            this.dialogo = true
        },
        abrirEdicao (e) {
            this.form = {
                id: e.id, servidor_id: e.servidor_id, funcao_servidor_id: e.funcao_servidor_id,
                data_inicio: (e.data_inicio || '').substring(0, 10),
                data_fim: (e.data_fim || '').substring(0, 10),
                ato_designacao: e.ato_designacao || '', principal: !!e.principal
            }
            this.dialogo = true
        },
        salvar () {
            const url = this.form.id
                ? `${this.$store.state.config.baseUrlApi}/api/equipe-diretiva/update/${this.form.id}`
                : `${this.$store.state.config.baseUrlApi}/api/equipe-diretiva/store`

            const payload = Object.assign({}, this.form, {
                instituicao_id: this.instituicaoId, periodo_letivo_id: this.periodoId
            })

            this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.dialogo = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        excluir (e) {
            this.$confirm('Excluir esta designação?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/equipe-diretiva/delete/${e.id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Designação excluída.', type: 'success' })
                    this.carregar()
                }).catch(err => this.$store.commit('throwException', err))
            }).catch(() => {})
        },
        dataBr (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]}`
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
